import { withUI2FormContext } from 'shared-libs/components/ui2/forms/ui2-form/with-ui2-form-context'
import { withOptionSource } from 'browser/components/atomic-elements/molecules/fields/option-source-select'

import { UI2Form } from './forms/ui2-form/ui2-form'
import { UI2FormSection } from './forms/ui2-form-section/ui2-form-section'
import { UI2Banner } from './display/ui2-banner/ui2-banner'
import { UI2Icon } from './display/ui2-icon/ui2-icon'
import { FormFocusTargetProvider } from './behavior/form-focus-target-provider'

/**
 * UI2 component registry: maps each UI2 component to its `ui2:` schema `type`,
 * the key the entity renderer resolves from `componentsMap`. Components that
 * need formDensity injected are wrapped in `withUI2FormContext`; UI2Form and
 * display-only components are exported unwrapped.
 */
export default {
  UI2Form,
  UI2FormSection: withUI2FormContext(UI2FormSection),
  UI2Banner,
  UI2Icon,
  FormFocusTargetProvider,
}

